import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { ProposalEditor } from './ProposalEditor';
import { ProposalView } from './ProposalView';

export const ProposalTab = ({ cid, isDesigner, chatImages, onPublished }) => {
  const [p, setP] = useState(undefined);

  useEffect(() => {
    api.get(`/consultations/${cid}/proposal`).then(r => setP(r.data)).catch(() => setP(null));
  }, [cid]);

  if (p === undefined) return <p className="py-16 text-center text-stilo-ink2">Cargando propuesta…</p>;
  if (isDesigner) return <ProposalEditor cid={cid} initial={p} chatImages={chatImages} onPublished={onPublished} />;
  if (!p) {
    return (
      <div className="border border-stilo-ink/10 bg-white p-12 text-center" data-testid="proposal-pending">
        <p className="overline">Tu propuesta</p>
        <p className="font-serif text-3xl mt-3">Estoy preparándola con mimo.</p>
        <p className="text-stilo-ink2 mt-3 text-sm">Te avisaré en la conversación en cuanto esté lista.</p>
      </div>
    );
  }
  return <ProposalView cid={cid} p={p} />;
};
